import url from 'url'
import { NativeModules } from 'react-native'

/**
 * Web variant: react-native-web does not export TurboModuleRegistry, so we
 * read scriptURL from the NativeModules.SourceCode shim provided by the
 * web/react-native alias.
 */
export const getScriptHostname = (): string | null => {
  const scriptURL = NativeModules.SourceCode?.scriptURL
  return scriptURL ? url.parse(scriptURL).hostname : null
}
